import { render, staticRenderFns } from "./MissingForm.vue?vue&type=template&id=08612032&"
import script from "./MissingForm.vue?vue&type=script&lang=js&"
export * from "./MissingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports